import styled from 'styled-components';


const SectionheaderWrapper = styled.div`
height:100%;
.gap-1{
  gap:1rem;
}
.dropdownmask{
  z-index:999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.2);
  pointer-events: none;
  -moz-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
._overlay{
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  ${'' /* background: rgba(0,0,0,0.25); */}
  z-index: 999;
}
header{
  background:#fff;
  .top-bar{
    padding:30px 40px 10px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    align-items:center;
    justify-content:space-between;
    >h1{
      font-size:14px;
      color:#344177;
    }
    .user-profile-info{
      .user__profile{ 
        font-family: 'Open Sans',sans-serif;
        margin-left: auto;
        position: relative;
        .dropdownmask{
            z-index:999;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.2);
            pointer-events: none;
            -moz-backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
        }
        .thumb-inner{
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-align-items: center;
            -webkit-box-align: center;
            -webkit-flex-align: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            
            h1{
                font-family: 'Open Sans',sans-serif;
                font-size: 14px;
                font-weight:700;
                margin-right:15px;
            }
            .user-status{
              border: solid 1px #f6c933;
              padding: 5px 15px;
              color: #344177;
              font-weight: bold;
              font-size: 0.75rem;
              border-radius: 10px;
              margin-right: 10px;
              text-transform: uppercase;
              letter-spacing: normal;
              &.on-other-call{
                background:#f6c933;
                border-color:#f6c933;
                color:#344177;
              }
              &.available{
                background:#8ec93d;
                border-color:#8ec93d;
                color:#344177;
              }
              &.busy{
                background:#d05353;
                border-color:#d05353;
                color:#344177;
              }
              &.not-available-yet{
                background:#b2b9d6;
                border-color:#b2b9d6;
                color:#344177;
              }
            }
            img{
                width: 40px;
                height: 40px;
                border-radius:50%;
                cursor: pointer;
            }
            .thumb-initials{
                background: #B4BBD6;
                width: 50px;
                height: 50px;
                -webkit-text-decoration: none;
                text-decoration: none;
                display: block;
                border-radius: 50%;
                color: #fff;
                line-height: 50px;
                cursor: pointer;
                text-align: center;
            }
        }
        .userDropdown{
            font-family: 'Open Sans', sans-serif;
            z-index: 1000;
            position: absolute;
            top: 60px;
            background: #344177;
            right: 0px;
            width: 270px;
            border-radius: 5px;
            padding:15px 30px;
            box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.13);
            -moz-backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            &:before{
                content: '';
                width: 0;
                height: 0;
                border: 5px solid transparent;
                position: absolute;
                border-bottom-color: #344177;
                top: -10px;
                right: 18px;
            }
            .menu-header{
                font-family: 'Open Sans', sans-serif;
                border-bottom: 1px solid #485373;
                .profile-picture{
                    display: -webkit-box;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    -webkit-align-items: center;
                    -webkit-box-align: center;
                    -webkit-flex-align: center;
                    align-items: center;
                    -webkit-justify-content: center;
                    justify-content: center;
                    margin-bottom: 10px;
                }
                .profile-name{
                    color: white;
                    margin: 20px 0 10px 0;
                    text-align: center;
                }
                .profile-status{
                    isplay: -webkit-box;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    -webkit-align-items: center;
                    -webkit-box-align: center;
                    -webkit-flex-align: center;
                    align-items: center;
                    -webkit-justify-content: center;
                    justify-content: center;
                    color: white;
                    height: 25px;
                    margin-bottom: 10px;
                    font-size: 13px;
                    margin-left: -22px;
                    .status-online{
                        border-radius: 50%;
                        width: 12px;
                        height: 12px;
                        background-color: #a3e74c;
                        margin-right: 10px;
                    }
                }
            }
            .menu-links{
                margin: 15px 0 0;
                .nav-link{
                    font-family: 'Open Sans', sans-serif;
                    line-height: 35px;
                    color: white;
                    display: block;
                }
            }
        }
    }
    }
  }
  .button-el{
    border:1px solid red;
  }
  ${'' /* .invite-dropdown{
        border:1px solid red;
   } */}
  .linkRow{
    padding:0 40px 30px;
    background:#fff;
    .linkRow-container{
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-direction: row;
      flex-direction: row;
      align-items:center;
      position: relative;
      z-index: 1000;
      .textBoxCont{
        min-width: 470px;
        
      }
      
      .phonefield{
          display: -webkit-box;
          display: -moz-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-flex-direction: row;
          flex-direction: row;
          align-items:center;
          justify-content:space-between;
          .copylink{
            cursor: pointer;
            right: 0;
            max-width: 170px;
            min-width: 140px;
            font-size: 1em;
            border: 1px solid #4eb0de;
            border-radius: 10px;
            display: block;
            text-transform: capitalize;
            text-align: center;
            color: #ffffff;
            font-weight: 600;
            background: #4eb0de;
            padding: 15px 20px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
          .copylink-textbox{
            background: #ffffff;
            padding: 15px 15px;
            width: 100%;
            border: 1px solid #b2b9d6;
            border-radius:10px 0 0 10px;
            &:focus{
              outline:none;
            }
          }
          .video-room-textbox{
            background: #f7f7f9;
            padding: 15px 15px;
            width: 100%;
            border: 1px solid #b2b9d6;
            border-radius:10px 0 0 10px;
            &:focus{
              outline:none;
            }
          }
        }
      .invite-source{
        ${'' /* margin-left:30px; */}
        .invite-via{
          cursor: pointer;
            right: 0;
            font-size: 1em;
            border: 1px solid #4eb0de;
            border-radius: 10px;
            display: block;
            text-transform: uppercase;
            text-align: left;
            color: #4eb0de;
            font-weight: 700;
            background: #ffffff;
            padding: 15px 30px 15px 20px;
            background-image:url('/images/downarrow.png');
            background-repeat: no-repeat;
            background-position: 95%;
            background-size: 13px;
            &.ant-dropdown-open{
              background-color: #f7f7f9;
              background-image:url('/images/uparrow.png');
            }
        }
      }
      .join-video-room{
        .invite-via{
            cursor: pointer;
            right: 0;
            font-size: 1em;
            border: 1px solid #4eb0de;
            border-radius: 10px;
            display: block;
            text-transform: uppercase;
            text-align: left;
            color: #4eb0de;
            font-weight: 700;
            background: #ffffff;
            padding: 15px 30px 15px 20px;
            background-image:url('/images/downarrow.png');
            background-repeat: no-repeat;
            background-position: 95%;
            background-size: 13px;
            ${'' /* transition: all 0.9s ease; */}
            &.ant-dropdown-open{
              background-color: #f7f7f9;
              background-image:url('/images/uparrow.png');
            }
        }
      }
    }
  }
}



`;


export default (SectionheaderWrapper);